import React from 'react';
import type { TraumatologiaData } from '../../hooks/useConsultationForm';
import FractureAssessment from './FractureAssessment';
import InjuryMechanism from './InjuryMechanism';
import PhysicalExam from './PhysicalExam';
import ImagingTreatment from './ImagingTreatment';
import SectionNumberBadge from '../SectionNumberBadge';

interface TraumatologiaSectionProps {
  traumatologiaData: TraumatologiaData;
  setTraumatologiaField: (section: keyof TraumatologiaData, field: string, value: any) => void;
  sectionNumber?: string;
}

const NEUROVASCULAR_FIELDS = new Set([
  'motor_function', 'sensory_function', 'distal_pulse', 'capillary_fill', 'compartment_syndrome_suspected',
]);

const TraumatologiaSection: React.FC<TraumatologiaSectionProps> = ({ traumatologiaData, setTraumatologiaField, sectionNumber }) => {
  return (
    <div className="row mb-4" data-section="traumatologica">
      <div className="col-sm-12">
        <div className="card border-warning">
          <div className="card-header text-white" style={{ backgroundColor: '#ea580c' }}>
            <h4 className="card-title mb-0">
              {sectionNumber && <SectionNumberBadge number={sectionNumber} inverse />}
              <i className="fa fa-bone me-2"></i>
              Evaluación Traumatológica
            </h4>
          </div>
          <div className="card-body">
            <FractureAssessment
              data={traumatologiaData.fracture}
              onChange={(field, value) => setTraumatologiaField('fracture', field, value)}
            />

            <InjuryMechanism
              data={traumatologiaData.injury_mechanism}
              onChange={(field, value) => setTraumatologiaField('injury_mechanism', field, value)}
            />

            <PhysicalExam
              data={{
                ...traumatologiaData.neurovascular_exam,
                ...traumatologiaData.physical_exam_trauma,
              }}
              onChange={(field, value) => {
                if (NEUROVASCULAR_FIELDS.has(field)) {
                  setTraumatologiaField('neurovascular_exam', field, value);
                } else {
                  setTraumatologiaField('physical_exam_trauma', field, value);
                }
              }}
            />

            <ImagingTreatment
              imaging={traumatologiaData.imaging}
              treatment={traumatologiaData.treatment}
              complications={traumatologiaData.complications}
              onFieldChange={(section, field, value) =>
                setTraumatologiaField(section as keyof TraumatologiaData, field, value)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TraumatologiaSection;
